import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------

const getPollingTokenDetails = async (requestData) => {
	try {
		const { jwtToken, requestId } = { ...requestData };

		const isDev = false;

		const tempAccessToken =
			"eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJodHRwczovL2Rldi5lbGlmZWluc3VyZS5jb20uYXUvb2F1dGgyL3Rva2VuIiwiaXNzIjoidGVybWxpZmUtYXBpLmRldiIsInN1YiI6InRlcm1saWZlLWFwaS5kZXYuand0IiwiaWF0IjoxNzA0OTcwNzQxLCJleHAiOjE3MDQ5OTk1NDEsImp0aSI6IjkzY2JkYzg5LTQzODktNDM4MC04Yjg4LTVmMTAwZGQwZTIyMiIsInFpZCI6IjYzNFFBMzQ1NzNBTFAiLCJlbHRpZCI6ImVmOGEzNzQyLTk3MjUtNGY1MC1iYTU4LWNkMDc2Y2Q3Nzk5OSIsIm9rdGFVc2VySWQiOiIwMHUzanN3Z3I2cjZVdlpKYzNsNyIsImNjX3VzZXIiOnRydWUsInVzZXJuYW1lIjoiamNxYiIsImZpcnN0TmFtZSI6IkNvbGluIiwibGFzdE5hbWUiOiJCeXJuZSJ9.Lrnq-Vmg1Aaau0EefOZRMamy2A6aSx1ADb1CHzekTAY";

		const jwtAccessToken = isDev === true ? tempAccessToken : jwtToken;

		const response = await request({
			url: `/tokenDetails/${requestId}`,
			method: "GET",
			accessToken: jwtAccessToken,
		});

		const returnResponse = response?.data;
		return returnResponse;
	} catch (ex) {
		console.error(ex);
	}
};

let captured = false; // Variable to track captured status

export const useGetPollingTokenDetails = (requestData) =>
	useQuery({
		queryKey: [queryKeys.GET_POLLING_PAYMENT_TOKEN, requestData.requestId],
		queryFn: async () => {
			const response = await getPollingTokenDetails(requestData);
			if (response && response?.captured) {
				captured = true; // Update captured status
			} else {
				captured = false;
			}
			return response;
		},
		onError: (err) => {
			console.log("Error", err);
		},
		refetchInterval: captured ? false : 2000, // Stop polling when captured is true
		refetchOnWindowFocus: false,
		enabled:
			!!requestData?.jwtToken &&
			!!requestData.requestId &&
			!captured &&
			requestData?.enabled, // Enable if not captured
	});
